import {DateGroupGranularityType} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/DatePropertyTypeStrategy/enum/DateGroupGranularityType'
import {IDatePropertyTypeFullValue} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/DatePropertyTypeStrategy/types/IDatePropertyTypeInterfaces'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {IGroupGranularityDescriptor} from '@toolify/client/src/modules/databases/utils/groupSortModes'
import {bucketDateValueByGranularity} from '@toolify/client/src/modules/databases/utils/bucketDateValueByGranularity'

export const DATE_GRANULARITY_SHORT_LABEL_KEYS: Record<DateGroupGranularityType, string> = {
  [DateGroupGranularityType.Day]: 'database.header.granularityDayShort',
  [DateGroupGranularityType.Week]: 'database.header.granularityWeekShort',
  [DateGroupGranularityType.Month]: 'database.header.granularityMonthShort',
  [DateGroupGranularityType.Quarter]: 'database.header.granularityQuarterShort',
  [DateGroupGranularityType.Year]: 'database.header.granularityYearShort',
}

export const DATE_GRANULARITY_FULL_LABEL_KEYS: Record<DateGroupGranularityType, string> = {
  [DateGroupGranularityType.Day]: 'database.header.granularityDay',
  [DateGroupGranularityType.Week]: 'database.header.granularityWeek',
  [DateGroupGranularityType.Month]: 'database.header.granularityMonth',
  [DateGroupGranularityType.Quarter]: 'database.header.granularityQuarter',
  [DateGroupGranularityType.Year]: 'database.header.granularityYear',
}

export const dateGroupGranularityDescriptor: IGroupGranularityDescriptor = {
  getDefault: () => DateGroupGranularityType.Day,
  getValues: () => Object.values(DateGroupGranularityType),
  getFullLabelKey: (value: string): string =>
    DATE_GRANULARITY_FULL_LABEL_KEYS[value as DateGroupGranularityType] ?? '',
  getShortLabelKey: (value: string): string =>
    DATE_GRANULARITY_SHORT_LABEL_KEYS[value as DateGroupGranularityType] ?? '',
  icon: IconNameType.Calendar,
  bucketValue: (_value, fullValue, granularity) => {
    const bucketedValue = bucketDateValueByGranularity(fullValue as IDatePropertyTypeFullValue | null, granularity)
    return {
      value: bucketedValue,
      fullValue: bucketedValue,
    }
  },
}

export function buildDayDateBucketValue(date: string | null | undefined): IDatePropertyTypeFullValue | null {
  if(!date) {
    return null
  }
  return {
    from: {
      date,
      time: null,
    },
    to: {
      date: null,
      time: null,
    },
  }
}

export const entityWithDateGroupGranularityDescriptor: IGroupGranularityDescriptor = {
  ...dateGroupGranularityDescriptor,
  bucketValue: (_value, fullValue, granularity) => {
    const date = (fullValue as {date?: string} | null)?.date?.slice(0, 10)
    const dayBucketValue = buildDayDateBucketValue(date)
    if(!dayBucketValue) {
      return null
    }
    const bucketedValue = bucketDateValueByGranularity(dayBucketValue, granularity)
    return {
      value: bucketedValue,
      fullValue: bucketedValue,
    }
  },
}
